import loginAPPService from "@/services/loginAPPService";
import { initInitData, retrieveLaunchParams } from "@telegram-apps/sdk";
import axios, { AxiosError } from "axios";

import * as Sentry from "@sentry/nextjs";
import logoutService from "@/services/logoutService";

const domain = process.env.NEXT_PUBLIC_SERVER_DOMAIN;

export const userRequest = axios.create({
    baseURL: "/api",
    timeout: 60000,
});

// Add a response interceptor to handle errors globally
userRequest.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle the error response
        let errorMessage = "An error occurred while processing the request.";
        let errorDetails: any = {};

        if (error.response) {
            // The server responded with a status code outside the range of 2xx
            errorMessage = `Server Error: ${error.response.status} - ${error.message}`;
            errorDetails = {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers,
                config: error.config, // Configuration of the request that caused the error
            };
        } else if (error.request) {
            // The request was made but no response was received
            errorMessage = "No response received from the server.";
            errorDetails = {
                request: error.request,
                config: error.config, // Configuration of the request that caused the error
            };
        } else {
            // An error occurred while setting up the request (e.g., incorrect URL)
            errorMessage = `Request setup error: ${error.message}`;
            errorDetails = {
                message: error.message,
                config: error.config, // Configuration of the request that caused the error
            };
        }

        // Log the error to the console for debugging purposes
        console.error("🚀 ~ Axios Interceptor Error:", {
            message: errorMessage,
            details: errorDetails,
        });

        // Capture the error with Sentry, including additional context
        Sentry.captureException(new AxiosError(errorMessage), {
            extra: {
                ...errorDetails,
                info: errorDetails.data.message,
            },
        });

        // Reject the Promise with the processed error details
        return Promise.reject({ ...error });
    }
);

let timesRetry = 0;

export const get = async (url: string, option?: any) => {
    let key, hash;
    try {
        const rawData = retrieveLaunchParams();
        hash = rawData?.initDataRaw;
        key = "telegram";
    } catch (error) {
        key = "casdoor";
    }
    try {
        const res = await userRequest.get(`${url}?key=accountInfo-${key}`, {
            ...option,
        });
        return res.data;
    } catch (err: any) {
        timesRetry++;
        if (err.response.status === 401) {
            if (key === "casdoor") {
                document.cookie = `sessionCasdoor=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                return;
            } else {
                if (timesRetry >= 3) return;
                const loginRes = await loginAPPService("", "telegram", hash as string);
                if (!loginRes) throw err;
                const retryRes: any = await get(url, option);
                timesRetry = 0;
                return retryRes;
            }
        }
        timesRetry++;
        if (err?.status === 401) {
            if (timesRetry >= 3) return;
            console.log("no user");
            const loginRes = await loginAPPService("", "telegram", hash as string);
            if (!loginRes) throw err;
            const retryRes: any = await get(url, option);
            timesRetry = 0;
            return retryRes;
        }
    }
};

export const post = async (url: string, data?: any, headers?: any) => {
    let key, hash;
    try {
        const rawData = retrieveLaunchParams();
        hash = rawData?.initDataRaw;
        key = "telegram";
    } catch (error) {
        key = "casdoor";
    }
    try {
        const res = await userRequest.post(`${url}?key=accountInfo-${key}`, data, {});
        return res.data;
    } catch (err: any) {
        timesRetry++;
        console.log(err, "err");
        if (err.response.status === 401) {
            if (key === "casdoor") {
                document.cookie = `sessionCasdoor=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                return;
            } else {
                if (timesRetry >= 3) return;
                const loginRes = await loginAPPService("", "telegram", hash as string);
                if (!loginRes) throw err;
                const retryRes: any = await post(url, data, headers);
                timesRetry = 0;
                return retryRes;
            }
        }
        timesRetry++;
        if (err?.status === 401) {
            if (timesRetry >= 3) return;
            console.log("no user");
            const loginRes = await loginAPPService("", "telegram", hash as string);
            if (!loginRes) throw err;
            const retryRes: any = await post(url, data, headers);
            timesRetry = 0;
            return retryRes;
        }
    }
};
export const patch = async (url: string, data?: any, headers?: any) => {
    let key, hash;
    try {
        const rawData = retrieveLaunchParams();
        hash = rawData?.initDataRaw;
        key = "telegram";
    } catch (error) {
        key = "casdoor";
    }
    try {
        const res = await userRequest.patch(`${url}?key=accountInfo-${key}`, data, {});
        return res.data;
    } catch (err: any) {
        timesRetry++;
        if (err.response.status === 401) {
            if (key === "casdoor") {
                document.cookie = `sessionCasdoor=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                return;
            } else {
                if (timesRetry >= 3) return;
                const loginRes = await loginAPPService("", "telegram", hash as string);
                if (!loginRes) throw err;
                const retryRes: any = await patch(url, data, headers);
                timesRetry = 0;
                return retryRes;
            }
        }
        timesRetry++;
        if (err?.status === 401) {
            if (timesRetry >= 3) return;
            console.log("no user");
            const loginRes = await loginAPPService("", "telegram", hash as string);

            if (!loginRes) throw err;
            const retryRes: any = await patch(url, data, headers);
            timesRetry = 0;
            return retryRes;
        }
    }
};
export const put = async (url: string, data?: any, headers?: any) => {
    let key, hash;
    try {
        const rawData = retrieveLaunchParams();
        hash = rawData?.initDataRaw;
        key = "telegram";
    } catch (error) {
        key = "casdoor";
    }
    try {
        const res = await userRequest.put(`${url}?key=accountInfo-${key}`, data, {});
        return res.data;
    } catch (err: any) {
        timesRetry++;
        if (err.response.status === 401) {
            if (key === "casdoor") {
                document.cookie = `sessionCasdoor=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                return;
            } else {
                if (timesRetry >= 3) return;
                const loginRes = await loginAPPService("", "telegram", hash as string);
                if (!loginRes) throw err;
                const retryRes: any = await put(url, data, headers);
                timesRetry = 0;
                return retryRes;
            }
        }
        timesRetry++;
        if (err?.status === 401) {
            if (timesRetry >= 3) return;
            console.log("no user");
            const loginRes = await loginAPPService("", "telegram", hash as string);
            if (!loginRes) throw err;
            const retryRes: any = await patch(url, data, headers);
            timesRetry = 0;
            return retryRes;
        }
    }
};
export const deleteRequest = async (url: string, data?: any, headers?: any) => {
    let key, hash;
    try {
        const rawData = retrieveLaunchParams();
        hash = rawData?.initDataRaw;
        key = "telegram";
    } catch (error) {
        key = "casdoor";
    }
    try {
        const res = await userRequest.delete(`${url}?key=accountInfo-${key}`, {
            data,
        });
        return res.data;
    } catch (err: any) {
        timesRetry++;
        if (err.response.status === 401) {
            if (key === "casdoor") {
                document.cookie = `sessionCasdoor=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                return;
            } else {
                if (timesRetry >= 3) return;
                const loginRes = await loginAPPService("", "telegram", hash as string);
                if (!loginRes) throw err;
                const retryRes: any = await deleteRequest(url, data, headers);
                timesRetry = 0;
                return retryRes;
            }
        }
        timesRetry++;
        if (err?.status === 401) {
            if (timesRetry >= 3) return;
            console.log("no user");
            const loginRes = await loginAPPService("", "telegram", hash as string);
            if (!loginRes) throw err;
            const retryRes: any = await deleteRequest(url, data, headers);
            timesRetry = 0;
            return retryRes;
        }
    }
};
